export default "__VITE_ASSET__DPRBjJOI__"